export default "__VITE_ASSET__BpjN8GRf__"